(function () {
  'use strict';

  /* ============================================================
     System Builder -- Installation Diagram (SVG)
     Generates a plumbing schematic from selected water treatment
     systems. Horizontal layout, scales via SVG viewBox.
     ============================================================ */

  // ---- Layout constants (SVG units) ----
  var PY   = 50;    // pipe center Y
  var OY   = 8;     // outlet symbols (wall)
  var FY   = 228;   // floor line
  var LY   = 242;   // label baseline
  var DY   = 268;   // drain end
  var CH   = 296;   // canvas height
  var GAP  = 42;    // gap between components
  var MARG = 20;    // left/right margin
  var PW   = 3.5;   // pipe stroke width

  // ---- Colors ----
  var C = {
    pipe: '#6d7a80', pipeMuted: '#b5bcc0',
    tankDark: '#2a2a2a', tankDarkHi: '#3a3a3a',
    tankLight: '#d5cebf', tankLightHi: '#e0d9cc',
    valve: '#303030', port: '#404040',
    display: '#6eb5ff', btn: '#505050',
    clackRed: '#bc3a2e',
    blue: '#2980b9', blueHi: '#3490ca',
    cap: '#2a3540',
    stainless: '#a8b0b8', stainlessHi: '#bac2ca', stainlessDk: '#8a9199',
    wellBlue: '#28709e', wellBlueHi: '#3580ae',
    brine: '#2e2e2e', brineLid: '#3a3a3a',
    floor: '#ddd', wall: '#e5e5e5',
    outPlate: '#eeeee5', outBorder: '#aaa8a0',
    cord: '#888', drain: '#90a0a8',
    label: '#2a3545', labelSub: '#8494a4',
    arrow: '#5a6a7a',
    hWall: '#ddd0b8', hRoof: '#8a5835', hDoor: '#6a3a1a', hWin: '#a8d5e5'
  };

  // ---- System metadata ----
  var META = {
    sediment:         { type: 'bigblue',  hasDrain: false, needsPower: false },
    iron_filter:      { type: 'mineral',  tColor: C.tankDark, tHi: C.tankDarkHi, vType: 'fleck2510', hasDrain: true,  needsPower: true,  powerType: 'standard' },
    acid_neutralizer: { type: 'mineral',  tColor: C.tankLight, tHi: C.tankLightHi, vType: 'clack',     hasDrain: false, needsPower: false },
    acid_neutralizer_bw: { type: 'mineral', tColor: C.tankLight, tHi: C.tankLightHi, vType: 'fleck2510', hasDrain: true, needsPower: true, powerType: 'standard' },
    water_softener:   { type: 'softener', hasDrain: true,  needsPower: true,  powerType: 'standard' },
    carbon_filter:    { type: 'mineral',  tColor: C.tankLight, tHi: C.tankLightHi, vType: 'clack',     hasDrain: false, needsPower: false },
    carbon_filter_bw: { type: 'mineral',  tColor: C.tankLight, tHi: C.tankLightHi, vType: 'fleck2510', hasDrain: true, needsPower: true, powerType: 'standard' },
    uv_system:        { type: 'uv',       hasDrain: false, needsPower: true,  powerType: 'gfci' }
  };

  function getMeta(sysId, isBackwashing) {
    if (isBackwashing && META[sysId + '_bw']) return META[sysId + '_bw'];
    return META[sysId];
  }


  // ==== COMPONENT DRAWING FUNCTIONS ====
  // Each returns { width, svg }. Drawn at origin, engine translates.

  function mineralTank(color, hi, valve) {
    var w = 70, s = '';

    // Base ring
    s += '<rect x="11" y="220" width="48" height="8" rx="2" fill="#1a1a1a"/>';

    // Tank body
    s += '<rect x="15" y="68" width="40" height="152" rx="2" fill="' + color + '"/>';
    // Dome
    s += '<ellipse cx="35" cy="68" rx="20" ry="9" fill="' + color + '"/>';
    // Highlight strip
    s += '<rect x="22" y="72" width="6" height="140" rx="3" fill="' + hi + '" opacity="0.3"/>';
    // Wrap lines
    var wo = color === C.tankDark ? '0.07' : '0.12';
    for (var y = 88; y < 215; y += 18) {
      s += '<line x1="16" y1="' + y + '" x2="54" y2="' + y + '" stroke="rgba(0,0,0,' + wo + ')" stroke-width="0.5"/>';
    }
    // Logo
    var lc = color === C.tankDark ? 'rgba(80,140,220,0.2)' : 'rgba(0,80,160,0.12)';
    s += '<circle cx="35" cy="196" r="5" fill="' + lc + '"/>';

    // Valve head
    if (valve === 'fleck2510' || valve === 'fleck5600') {
      s += '<rect x="12" y="32" width="46" height="28" rx="3" fill="' + C.valve + '"/>';
      s += '<rect x="1" y="43" width="13" height="12" rx="2" fill="' + C.port + '"/>';
      s += '<rect x="56" y="43" width="13" height="12" rx="2" fill="' + C.port + '"/>';
      s += '<rect x="21" y="36" width="18" height="10" rx="1.5" fill="' + C.display + '" opacity="0.5"/>';
      if (valve === 'fleck5600') {
        s += '<circle cx="25" cy="53" r="1.8" fill="' + C.btn + '"/>';
        s += '<circle cx="32" cy="53" r="1.8" fill="' + C.btn + '"/>';
        s += '<circle cx="39" cy="53" r="1.8" fill="' + C.btn + '"/>';
      }
    } else if (valve === 'clack') {
      s += '<rect x="14" y="34" width="42" height="24" rx="10" fill="' + C.valve + '"/>';
      s += '<rect x="23" y="29" width="6" height="7" rx="1.5" fill="' + C.clackRed + '"/>';
      s += '<rect x="41" y="29" width="6" height="7" rx="1.5" fill="' + C.clackRed + '"/>';
      s += '<rect x="3" y="40" width="13" height="14" rx="3" fill="' + C.port + '"/>';
      s += '<rect x="54" y="40" width="13" height="14" rx="3" fill="' + C.port + '"/>';
    }

    return { width: w, svg: s };
  }

  function brineTank() {
    var w = 38, s = '';
    s += '<rect x="0" y="118" width="' + w + '" height="110" rx="3" fill="' + C.brine + '"/>';
    s += '<polygon points="0,118 ' + w + ',118 ' + w + ',104 ' + (w * 0.55) + ',98" fill="' + C.brineLid + '"/>';
    s += '<rect x="' + (w / 2 - 6) + '" y="96" width="12" height="4" rx="2" fill="#505050"/>';
    s += '<text x="' + (w / 2) + '" y="178" font-size="7" fill="#666" text-anchor="middle" font-family="sans-serif">SALT</text>';
    return { width: w, svg: s };
  }

  function softenerComposite() {
    var tank = mineralTank(C.tankDark, C.tankDarkHi, 'fleck5600');
    var bt = brineTank();
    var brineX = tank.width + 5;
    var totalW = brineX + bt.width;
    var s = tank.svg;

    // Brine tank
    s += '<g transform="translate(' + brineX + ',0)">' + bt.svg + '</g>';

    // Brine line from valve to tank
    s += '<path d="M52 56 Q 56 62, 56 70 L 56 110 Q 56 118, ' + (brineX + 8) + ' 118" ' +
         'stroke="' + C.cord + '" stroke-width="1.2" fill="none" stroke-dasharray="3,2"/>';

    // Pipe passthrough from right port of mineral tank to right edge of component
    s += '<line x1="69" y1="' + PY + '" x2="' + totalW + '" y2="' + PY + '" ' +
         'stroke="' + C.pipe + '" stroke-width="' + PW + '" stroke-linecap="round"/>';

    return { width: totalW, svg: s };
  }

  function bigBlue() {
    var w = 52, s = '';

    // Bracket
    s += '<rect x="8" y="26" width="36" height="14" rx="1.5" fill="#eee" stroke="#ccc" stroke-width="0.5"/>';
    s += '<circle cx="16" cy="32" r="2" fill="none" stroke="#bbb" stroke-width="0.5"/>';
    s += '<circle cx="36" cy="32" r="2" fill="none" stroke="#bbb" stroke-width="0.5"/>';

    // Cap
    s += '<rect x="6" y="40" width="40" height="14" rx="3" fill="' + C.cap + '"/>';
    s += '<rect x="0" y="43" width="8" height="8" rx="2" fill="' + C.cap + '"/>';
    s += '<rect x="44" y="43" width="8" height="8" rx="2" fill="' + C.cap + '"/>';

    // Housing
    s += '<rect x="9" y="54" width="34" height="78" rx="2" fill="' + C.blue + '"/>';
    s += '<ellipse cx="26" cy="132" rx="17" ry="8" fill="' + C.blue + '"/>';
    // Highlight
    s += '<rect x="17" y="56" width="5" height="72" rx="2.5" fill="' + C.blueHi + '" opacity="0.3"/>';
    // Ribs
    for (var i = 0; i < 9; i++) {
      s += '<line x1="' + (11 + i * 3.7) + '" y1="56" x2="' + (11 + i * 3.7) + '" y2="130" stroke="rgba(0,0,0,0.1)" stroke-width="0.5"/>';
    }

    return { width: w, svg: s };
  }

  function uvSystem() {
    var w = 48, s = '';

    // Chamber (vertical tube)
    s += '<rect x="12" y="58" width="20" height="152" rx="10" fill="' + C.stainless + '"/>';
    s += '<rect x="18" y="60" width="5" height="146" rx="2.5" fill="' + C.stainlessHi + '" opacity="0.35"/>';
    // End caps
    s += '<ellipse cx="22" cy="58" rx="10" ry="5" fill="' + C.stainlessDk + '"/>';
    s += '<ellipse cx="22" cy="210" rx="10" ry="5" fill="' + C.stainlessDk + '"/>';

    // Side fittings at pipe level
    s += '<rect x="0" y="' + (PY - 4) + '" width="14" height="8" rx="2" fill="' + C.stainlessDk + '"/>';
    s += '<rect x="30" y="' + (PY - 4) + '" width="18" height="8" rx="2" fill="' + C.stainlessDk + '"/>';

    // Controller module on side
    s += '<rect x="34" y="90" width="12" height="28" rx="2" fill="#ddd5c5" stroke="#bbb0a0" stroke-width="0.5"/>';
    s += '<circle cx="40" cy="96" r="1.5" fill="#e03020"/>';

    // Cord from chamber to controller
    s += '<path d="M32 105 L 34 105" stroke="' + C.cord + '" stroke-width="1" fill="none"/>';

    // Label
    s += '<text x="22" y="140" font-size="5.5" fill="' + C.blue + '" font-weight="700" ' +
         'transform="rotate(-90,22,140)" text-anchor="middle" font-family="sans-serif" letter-spacing="0.8">VIQUA</text>';

    return { width: w, svg: s };
  }

  function wellTank() {
    var w = 72, cx = 36, s = '';
    var pipeLeft = 4, pipeRight = w - 4;

    // Tank body -- capsule shape
    var bTop = 60, bBot = 186, bW = 44, bR = 22;
    var bx = cx - bW / 2;
    s += '<rect x="' + bx + '" y="' + (bTop + bR) + '" width="' + bW + '" height="' + (bBot - bTop - bR * 2) + '" fill="' + C.wellBlue + '"/>';
    s += '<ellipse cx="' + cx + '" cy="' + (bTop + bR) + '" rx="' + bR + '" ry="' + bR + '" fill="' + C.wellBlue + '"/>';
    s += '<ellipse cx="' + cx + '" cy="' + (bBot - bR) + '" rx="' + bR + '" ry="' + bR + '" fill="' + C.wellBlue + '"/>';
    s += '<rect x="' + (cx - 7) + '" y="' + (bTop + 8) + '" width="6" height="' + (bBot - bTop - 16) + '" rx="3" fill="' + C.wellBlueHi + '" opacity="0.2"/>';

    // Label band
    s += '<rect x="' + (bx + 3) + '" y="' + (cx + 80) + '" width="' + (bW - 6) + '" height="13" rx="2" fill="rgba(180,200,80,0.35)"/>';
    s += '<text x="' + cx + '" y="' + (cx + 90) + '" font-size="4" fill="#2a5a2a" text-anchor="middle" font-family="sans-serif" font-weight="600">WELL-X-TROL</text>';

    // Bottom fitting where pipe connects
    var fitY = bBot + 2;
    s += '<rect x="' + (cx - 4) + '" y="' + (bBot - 4) + '" width="8" height="10" rx="2" fill="#5a6a7a"/>';

    // Pipe routing: horizontal in at PY -> down left side -> across bottom -> up right side -> horizontal out at PY
    var bottomY = fitY + 8;
    // Left horizontal in
    s += '<line x1="0" y1="' + PY + '" x2="' + pipeLeft + '" y2="' + PY + '" stroke="' + C.pipe + '" stroke-width="' + PW + '" stroke-linecap="round"/>';
    // Left vertical down
    s += '<line x1="' + pipeLeft + '" y1="' + PY + '" x2="' + pipeLeft + '" y2="' + bottomY + '" stroke="' + C.pipe + '" stroke-width="' + PW + '" stroke-linecap="round"/>';
    // Bottom horizontal across (under the tank)
    s += '<line x1="' + pipeLeft + '" y1="' + bottomY + '" x2="' + pipeRight + '" y2="' + bottomY + '" stroke="' + C.pipe + '" stroke-width="' + PW + '" stroke-linecap="round"/>';
    // Tee up into tank fitting
    s += '<line x1="' + cx + '" y1="' + bottomY + '" x2="' + cx + '" y2="' + (bBot - 2) + '" stroke="' + C.pipe + '" stroke-width="' + PW + '" stroke-linecap="round"/>';
    // Right vertical up
    s += '<line x1="' + pipeRight + '" y1="' + bottomY + '" x2="' + pipeRight + '" y2="' + PY + '" stroke="' + C.pipe + '" stroke-width="' + PW + '" stroke-linecap="round"/>';
    // Right horizontal out
    s += '<line x1="' + pipeRight + '" y1="' + PY + '" x2="' + w + '" y2="' + PY + '" stroke="' + C.pipe + '" stroke-width="' + PW + '" stroke-linecap="round"/>';

    return { width: w, svg: s };
  }

  function houseIcon() {
    var w = 65, s = '';
    var bx = 10, bw = 50, bt = 130, bh = 96;

    // Pipe entry
    s += '<rect x="0" y="' + (PY - 3) + '" width="' + (bx + 4) + '" height="6" rx="1" fill="#888"/>';
    // Pipe going down into house
    s += '<line x1="' + (bx + 3) + '" y1="' + PY + '" x2="' + (bx + 3) + '" y2="' + (bt + 10) + '" stroke="' + C.pipe + '" stroke-width="' + PW + '"/>';

    // Body
    s += '<rect x="' + bx + '" y="' + bt + '" width="' + bw + '" height="' + bh + '" rx="2" fill="' + C.hWall + '"/>';
    // Roof
    var peak = bt - 36;
    s += '<polygon points="' + (bx - 4) + ',' + bt + ' ' + (bx + bw / 2) + ',' + peak + ' ' + (bx + bw + 4) + ',' + bt + '" fill="' + C.hRoof + '"/>';
    // Door
    s += '<rect x="' + (bx + bw / 2 - 8) + '" y="' + (bt + bh - 42) + '" width="16" height="42" rx="1.5" fill="' + C.hDoor + '"/>';
    s += '<circle cx="' + (bx + bw / 2 + 5) + '" cy="' + (bt + bh - 18) + '" r="1.5" fill="#b8a080"/>';
    // Windows
    var wy = bt + 16;
    s += '<rect x="' + (bx + 8) + '" y="' + wy + '" width="12" height="12" rx="1" fill="' + C.hWin + '" stroke="#b8a080" stroke-width="0.5"/>';
    s += '<line x1="' + (bx + 14) + '" y1="' + wy + '" x2="' + (bx + 14) + '" y2="' + (wy + 12) + '" stroke="#b8a080" stroke-width="0.5"/>';
    s += '<line x1="' + (bx + 8) + '" y1="' + (wy + 6) + '" x2="' + (bx + 20) + '" y2="' + (wy + 6) + '" stroke="#b8a080" stroke-width="0.5"/>';
    s += '<rect x="' + (bx + bw - 20) + '" y="' + wy + '" width="12" height="12" rx="1" fill="' + C.hWin + '" stroke="#b8a080" stroke-width="0.5"/>';
    s += '<line x1="' + (bx + bw - 14) + '" y1="' + wy + '" x2="' + (bx + bw - 14) + '" y2="' + (wy + 12) + '" stroke="#b8a080" stroke-width="0.5"/>';
    s += '<line x1="' + (bx + bw - 20) + '" y1="' + (wy + 6) + '" x2="' + (bx + bw - 8) + '" y2="' + (wy + 6) + '" stroke="#b8a080" stroke-width="0.5"/>';

    return { width: w, svg: s };
  }


  // ==== CONNECTING ELEMENTS ====

  function pipe(x1, x2, muted) {
    return '<line x1="' + x1 + '" y1="' + PY + '" x2="' + x2 + '" y2="' + PY + '" ' +
           'stroke="' + (muted ? C.pipeMuted : C.pipe) + '" stroke-width="' + PW + '" stroke-linecap="round"/>';
  }

  function flowArrow(x) {
    return '<polygon points="' + (x - 4) + ',' + (PY - 4) + ' ' + (x + 4) + ',' + PY + ' ' + (x - 4) + ',' + (PY + 4) + '" fill="' + C.arrow + '"/>';
  }

  function ballValve(x) {
    return '<circle cx="' + x + '" cy="' + PY + '" r="5" fill="white" stroke="' + C.pipe + '" stroke-width="1.5"/>' +
           '<line x1="' + x + '" y1="' + (PY - 8) + '" x2="' + x + '" y2="' + (PY - 3) + '" stroke="' + C.pipe + '" stroke-width="2" stroke-linecap="round"/>';
  }

  function drainLine(x) {
    return '<line x1="' + x + '" y1="' + (PY + 14) + '" x2="' + x + '" y2="' + DY + '" ' +
           'stroke="' + C.drain + '" stroke-width="1.5" stroke-dasharray="4,3"/>' +
           '<text x="' + (x + 8) + '" y="' + (DY - 3) + '" font-size="9" fill="' + C.labelSub + '" font-family="sans-serif" font-weight="600">Drain</text>';
  }

  function outletSymbol(x, type) {
    var s = '';
    var lbl = type === 'gfci' ? 'GFCI' : '120V';
    s += '<rect x="' + (x - 8) + '" y="' + OY + '" width="16" height="18" rx="2" fill="' + C.outPlate + '" stroke="' + C.outBorder + '" stroke-width="0.7"/>';
    s += '<rect x="' + (x - 3) + '" y="' + (OY + 4) + '" width="2" height="5" rx="0.5" fill="#555"/>';
    s += '<rect x="' + (x + 1) + '" y="' + (OY + 4) + '" width="2" height="5" rx="0.5" fill="#555"/>';
    s += '<ellipse cx="' + x + '" cy="' + (OY + 13) + '" rx="2" ry="1.5" fill="none" stroke="#555" stroke-width="0.6"/>';
    s += '<text x="' + x + '" y="' + (OY - 3) + '" font-size="8" fill="' + C.label + '" text-anchor="middle" font-family="sans-serif" font-weight="700">' + lbl + '</text>';
    return s;
  }

  function powerCord(x, toY) {
    return '<line x1="' + x + '" y1="' + (OY + 18) + '" x2="' + x + '" y2="' + toY + '" ' +
           'stroke="' + C.cord + '" stroke-width="1" stroke-dasharray="3,2"/>';
  }

  function label(x, name, detail, owned) {
    var fc = owned ? C.labelSub : C.label;
    var s = '<text x="' + x + '" y="' + LY + '" font-size="12" fill="' + fc + '" text-anchor="middle" font-family="sans-serif" font-weight="700">' + name + '</text>';
    if (detail) {
      s += '<text x="' + x + '" y="' + (LY + 14) + '" font-size="10" fill="' + C.labelSub + '" text-anchor="middle" font-family="sans-serif">' + detail + '</text>';
    }
    if (owned) {
      s += '<text x="' + x + '" y="' + (LY + (detail ? 27 : 14)) + '" font-size="9" fill="' + C.labelSub + '" text-anchor="middle" font-family="sans-serif" font-style="italic">(Existing)</text>';
    }
    return s;
  }


  // ==== ASSEMBLY ENGINE ====

  function render(containerEl, DATA, state) {
    if (!containerEl) return;

    var active = [];
    DATA.categories.forEach(function (cat) {
      var s = state[cat.id];
      if (s.state !== 'skip') {
        var sizes = (s.backwashing && cat.backwashingSizes) ? cat.backwashingSizes : cat.sizes;
        active.push({ id: cat.id, name: cat.name, st: s.state, size: sizes[s.sizeIdx], backwashing: !!s.backwashing });
      }
    });

    if (active.length === 0) {
      containerEl.innerHTML = '';
      containerEl.style.display = 'none';
      return;
    }
    containerEl.style.display = 'block';

    var svg = '';
    var prevRight = MARG;

    // Defs
    svg += '<defs><filter id="sb-gray"><feColorMatrix type="saturate" values="0"/></filter></defs>';

    // Well tank
    var wt = wellTank();
    svg += '<g transform="translate(' + MARG + ',0)">' + wt.svg + '</g>';
    svg += flowArrow(MARG + 3);
    svg += '<text x="' + (MARG + 3) + '" y="' + (PY - 10) + '" font-size="9" fill="' + C.labelSub + '" text-anchor="middle" font-family="sans-serif" font-style="italic">From Well</text>';
    svg += label(MARG + wt.width / 2, 'Well / Pressure', 'Tank', false);
    prevRight = MARG + wt.width;

    // Systems
    active.forEach(function (sys) {
      var m = getMeta(sys.id, sys.backwashing);
      if (!m) return;

      var compX = prevRight + GAP;
      var owned = sys.st === 'have';

      // Pipe in gap
      svg += pipe(prevRight, compX, owned);
      svg += flowArrow(prevRight + GAP / 2);
      svg += ballValve(compX - 8);

      // Component
      var comp;
      if (m.type === 'mineral')       comp = mineralTank(m.tColor, m.tHi, m.vType);
      else if (m.type === 'softener') comp = softenerComposite();
      else if (m.type === 'bigblue')  comp = bigBlue();
      else if (m.type === 'uv')       comp = uvSystem();
      if (!comp) return;

      var wrap = '<g transform="translate(' + compX + ',0)"';
      if (owned) wrap += ' opacity="0.45" filter="url(#sb-gray)"';
      wrap += '>' + comp.svg + '</g>';
      svg += wrap;

      // Label
      var lx = compX + (m.type === 'softener' ? 35 : comp.width / 2);
      svg += label(lx, sys.name, sys.size.label, owned);

      // Drain
      if (m.hasDrain) {
        svg += drainLine(compX + 35);
      }

      // Power
      if (m.needsPower) {
        var px = compX + (m.type === 'uv' ? 22 : 35);
        svg += outletSymbol(px, m.powerType);
        svg += powerCord(px, 32);
      }

      prevRight = compX + comp.width;
    });

    // House
    var houseX = prevRight + GAP;
    svg += pipe(prevRight, houseX, false);
    svg += flowArrow(prevRight + GAP / 2);
    var h = houseIcon();
    svg += '<g transform="translate(' + houseX + ',0)">' + h.svg + '</g>';
    svg += label(houseX + h.width / 2, 'Your House', null, false);

    var totalW = houseX + h.width + MARG;

    // Floor line
    svg += '<line x1="0" y1="' + FY + '" x2="' + totalW + '" y2="' + FY + '" stroke="' + C.floor + '" stroke-width="0.8"/>';

    // Wrap in SVG element
    containerEl.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + totalW + ' ' + CH + '" ' +
      'width="100%" preserveAspectRatio="xMidYMid meet" ' +
      'style="display:block;max-width:100%;">' + svg + '</svg>';
  }


  // ==== EXPORT ====
  window.SystemBuilderDiagram = { render: render };

})();
